import { BindingEngine, customAttribute, inject } from 'aurelia-framework';
import PerfectScrollbar from 'perfect-scrollbar';
import { IMdcLookupElement } from '@aurelia-mdc-web/lookup';
import { AgGridAurelia } from '../../ag-grid-aurelia';
import { MdcDataTable } from '@aurelia-mdc-web/data-table';

@customAttribute('perfect-scrollbar')
@inject(Element, BindingEngine)
export class PerfectScrollbarCustomAttribute {
  constructor(private element: HTMLElement, private bindingEngine: BindingEngine) { }

  instance: PerfectScrollbar;
  observer = new MutationObserver(() => this.updateOnMutation());

  async attached() {
    if (this.element.tagName === 'MDC-SELECT') {
      this.element = (this.element as any).au.controller.viewModel.menuElement as HTMLElement;
    } else if (this.element.tagName === 'MDC-LOOKUP') {
      this.element = (this.element as unknown as IMdcLookupElement).au.controller.viewModel.menu.root;
    } else if (this.element.tagName === 'MDC-DATA-TABLE') {
      await ((this.element as any).au.controller.viewModel as MdcDataTable).initialised;
      this.element = this.element.querySelector('.mdc-data-table__table-container');
    } else if (this.element.tagName === 'AG-GRID-AURELIA') {
      const agGrid = (this.element as any).au.controller.viewModel as AgGridAurelia;
      let promiseResolve: (value: unknown) => void;
      const promise = new Promise(r => promiseResolve = r);
      const subscription = this.bindingEngine.propertyObserverEx(agGrid, 'api').subscribe(() => {
        subscription.dispose();
        promiseResolve(undefined);
      });
      await promise;
      this.element = this.element.querySelector('.ag-body-viewport');
    }
    this.element.style.position = 'relative';
    this.instance = new PerfectScrollbar(this.element, { wheelPropagation: true, scrollXMarginOffset: 1, scrollYMarginOffset: 1 });
    this.observer.observe(this.element, { childList: true, subtree: true });
    this.updateOnMutation();
  }

  detached() {
    if (this.instance) {
      this.instance.destroy();
      this.instance = undefined;
    }
    this.observer.disconnect();
  }

  updateOnMutation() {
    this.instance.update();
  }
}
